/* eslint-disable react/no-unused-prop-types */

import { Component } from 'react';
import Confetti from 'common/components/Confetti';
import { DateTime } from 'common/utils/date';

class KudoDisplay extends Component {
  constructor(props) {
    super();
    this.state = { ...props, confettiKey: 0, kudoPopover: false };
    this.completeKudo = this.completeKudo.bind(this);
    this.makeConfetti = this.makeConfetti.bind(this);
  }

  makeConfetti() {
    this.setState(({ confettiKey }) => ({ confettiKey: confettiKey + 1 }));
  }

  // prettier-ignore
  completeKudo(id) {
    $.ajax({ // eslint-disable-line no-undef
      url: `/api/v1/coaching/kudo/${id}/complete`,
      dataType: 'json',
      cache: false,
      type: 'PUT',
      contentType: 'application/json',
      success: function (kudo) { // eslint-disable-line func-names
        this.setState({ ...kudo });
      }.bind(this),
      error: function () { // eslint-disable-line func-names
        this.setState({ completedAt: false }); // eslint-disable-line react/no-unused-state
      }.bind(this),
    });
  }

  render() {
    const { id, text, completedAt, createdBy, createdAt, confettiKey, kudoPopover } = this.state;

    return (
      <div
        className="actions-and-kudo-display"
        data-kudo-completed={!!completedAt}
        onMouseEnter={() => {
          this.setState({ kudoPopover: true });
        }}
        onMouseLeave={() => {
          this.setState({ kudoPopover: false });
        }}
      >
        <div className="kudo-card">
          <div className="kudo-popover" data-popover-visible={kudoPopover}>
            <button className="celebrate-button" onClick={this.makeConfetti}>
              Celebrate
            </button>
            <button
              className="dismiss-button"
              onClick={() => {
                this.completeKudo(id, completedAt);
              }}
            >
              Dismiss
            </button>
          </div>
          {Boolean(confettiKey) && (
            <Confetti
              triggerKey={confettiKey}
              otherClassNames="fixed left-50 top-50"
              spread={100}
            />
          )}
          <div className="kudo-details">
            <i className="fa fa-smile" />
            <span className="takeaway-text">{text}</span>
          </div>
        </div>

        <div className="takeaway-status">
          <span>
            {createdBy} •{' '}
            {DateTime.fromISO(completedAt || createdAt).toLocaleString(
              DateTime.DATETIME_MED_WITH_SECONDS
            )}
          </span>
        </div>
      </div>
    );
  }
}

export default KudoDisplay;
